import { useViewportWidth } from '@redbubble/next/hooks';
import { DeviceType } from '@redbubble/next/types';

const itemsInViewByDeviceType = {
  [DeviceType.Mobile]: 2,
  [DeviceType.Tablet]: 4,
  [DeviceType.Desktop]: 6,
};

export const useResponsiveCarouselConfig = (
  initialDeviceType?: DeviceType,
  customItemsInViewByDeviceType = itemsInViewByDeviceType
): {
  recommendedItemsInView: number;
  recommendedProfile: DeviceType;
} => {
  const { isOrAbove } = useViewportWidth(initialDeviceType);

  if (isOrAbove(DeviceType.Desktop)) {
    return {
      recommendedItemsInView: customItemsInViewByDeviceType[DeviceType.Desktop],
      recommendedProfile: DeviceType.Desktop,
    };
  }

  if (isOrAbove(DeviceType.Tablet)) {
    return {
      recommendedItemsInView: customItemsInViewByDeviceType[DeviceType.Tablet],
      recommendedProfile: DeviceType.Desktop,
    };
  }

  return {
    recommendedItemsInView: customItemsInViewByDeviceType[DeviceType.Mobile],
    recommendedProfile: DeviceType.Mobile,
  };
};
